import { Component, OnInit } from '@angular/core';
import { ConsentService, Preferences } from '../core/services/consent.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-privacy-settings',
  templateUrl: './privacy-settings.component.html',
  styleUrls: ['./privacy-settings.component.scss']
})
export class PrivacySettingsComponent implements OnInit {
  prefs: Preferences = { analytics: false, marketing: false };
  loading = true;

  dropdownOpen = false;

  constructor(
    private consent: ConsentService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.consent.loadPreferences().subscribe({
      next: () => {
        this.prefs = this.consent.getLocalPreferences();
        this.loading = false;
      },
      error: () => {
        this.prefs = this.consent.getLocalPreferences();
        this.loading = false;
      }
    });
  }

  save() {
    this.consent.updatePreferences(this.prefs).subscribe(() => {
      // alert('Preferences updated.');
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

submitDSR(requestType: 'export' | 'delete' | 'restrict' | 'update') {
  this.dropdownOpen = false;

  const anonymousId = this.consent.getAnonymousId();
  const clpUser = localStorage.getItem("clpUser");
  const userObj = clpUser ? JSON.parse(clpUser) : null;
  const userId = userObj?.uid ? String(userObj.uid) : undefined;

  const formData = new FormData();
  formData.append('anon_id', anonymousId);
  formData.append('request_type', requestType);
  formData.append('status', 'pending');

  if (userId) {
    formData.append('user_id', userId);
  }

  this.http.post('https://hm-api.creatorott.com/gdpr/api/v1/create/dsr', formData)
    .subscribe({
      next: () => {
      error: (err) => {
        console.error(err);
        // alert('Error submitting request.');
      }
    }
    });
}

}
